export const isEmptyObj = (obj: object) => {
  return obj && Object.keys(obj).length === 0;
};
